import posthog from "posthog-js";

const initializePostHog = async () => {
  // Initialize PostHog with the provided key and host
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    capture_pageview: true,
    autocapture: true,
    person_profiles: "always",
    // Ensure session replays are linked to the identified user
    persistence: "localStorage+cookie",
    session_recording: { enabled: true },
  });

  const userInfoStr = localStorage.getItem("userInfo");
  if (!userInfoStr) return;

  try {
    const userInfo = JSON.parse(userInfoStr);
    const userId = userInfo?.data?.id;
    const phone = userInfo?.data?.phone;

    if (userId) {
      // 🧨 Reset current anonymous user session to clear previous distinct_id
      posthog.reset();

      // 👤 Identify user with userId as distinct_id and additional properties
      posthog.identify(userId.toString(), {
        phone_number: phone || "",
        // Optionally set userId as a person property for clarity
        user_id: userId.toString(),
      });
      posthog.capture("$identify", { $identified: true }); // Event đặc biệt để tạo person profile

      // Update PostHog local storage to prioritize userId as distinct_id and device_id
      const posthogStorageKey = `ph_${process.env.REACT_APP_POSTHOG_KEY}_posthog`;
      const posthogData = localStorage.getItem(posthogStorageKey);
      if (posthogData) {
        const parsedData = JSON.parse(posthogData);
        if (parsedData) {
          parsedData.distinct_id = userId.toString();
          // parsedData.device_id = userId.toString();
          localStorage.setItem(posthogStorageKey, JSON.stringify(parsedData));
        }
      }
    }
  } catch (e) {
    console.error("Failed to parse userInfo or update PostHog localStorage", e);
  }
};

export default initializePostHog;
